import axios from "axios";
import {Base_URL} from "../url"


const API_URL = "http://192.168.29.242:5090/api/TripDetails";

export const fetchTrips = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TripDetails/GetData`);
    console.log(response)
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching trips!";
  }
};
